export default "/images/82bcfc6fafdac1acb8c7e0a4dd49fc58.avif";